module.exports = __webpack_public_path__ + "img/ss03.abb2cc48.jpg";